import { Link } from "react-router-dom";

export default function GuideCta() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
          <i className="ri-book-open-line"></i>
          Подробное руководство
        </div>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
          Полное руководство по Yoybuy Sheet
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-7 leading-relaxed">
          Узнайте всё о том, как использовать таблицы Yoybuy для максимально выгодного шоппинга. Подробный гайд для начинающих и опытных пользователей.
        </p>
        <Link
          to="/yoybuy-spreadsheet-guide"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-heading font-semibold text-sm hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-right-line"></i>
          Читать руководство
        </Link>
      </div>
    </section>
  );
}